import { io } from "socket.io-client";

 const URL = "https://map.workw.com/";
// const URL = 'http://192.168.18.98:3000'
//Added local Socket Server for Testing
// const URL = "http://localhost:3000";
const socket = io(URL);

// emitters
export const emitRoomID=(data)=>{
    socket.emit('joinDocument',data)
}
//Socket Emitter for Chat
export const emitLiveComments = (data) => {
    socket.emit("comments", data);
};
//Socket Listener for Chats
export const listenerLiveComments = (updateMessageList) => {
    socket.on("comments", (data) => {
      data.color = "#98b3e6";
      data.margin = "5px auto 5px 0px"; //this styling work should be done through id
      updateMessageList(data);
    });
  };

export const listenerLiveCommentsOff = () => {
    socket.off("comments");
};

export default socket;
